export const disabledShortcuts = {
    "/actions/pen/remove": true,
    "/actions/pen/undo": true,
    "/actions/ensureFrozen": true,
    "/actions/spawnEmoji1": true,
    "/actions/spawnPen": true,
}